// used to render destination page (matches with backend)
export const DESTINATION_SEGMENT_ID = 'DESTINATION';
export const HOLIDAY_TYPE_SEGMENT_ID = 'HOLIDAY_TYPE';

// form type values for hero planner schedules
export const FORM_TYPE_DEFAULT = 'DEFAULT';
export const FORM_TYPE_CUSTOM = 'CUSTOM';

// campaign value surfaced on offer details when tagged + within the campaign window (see svc-customer-communication LUX_PLUS_MONTH_CAMPAIGN_DISPLAY_TAG)
export const LUX_PLUS_MONTH_CAMPAIGN = 'lux_plus_month';

// the `campaign` flag above is evaluated backend-side against "now" at fetch time, not against a schedule's
// send date, so we re-check the send date against this window ourselves before trusting the flag
export const LUX_PLUS_MONTH_CAMPAIGN_START_DATE = '2026-08-15T00:00:00+10:00';
export const LUX_PLUS_MONTH_CAMPAIGN_END_DATE = '2026-09-15T23:59:00+10:00';

// read-only page that checks the schedule every segment resolves to for a send date
export const HERO_PLANNER_DEBUG_PATH = '/customer-communication/hero-planner/debug';

export enum HERO_PLANNER_DEBUG_SEARCH_PARAMS {
  SEND_DATE = 'send-date',
  OFFER_ID = 'offer-id',
  SHOW = 'show',
  COUNTRY_GROUP = 'country-group',
  SHOW_UNSENT = 'show-unsent',
}
